var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22656 8C7.70781 8 8.11994 7.8432 8.46294 7.5296C8.80535 7.21653 8.97656 6.84 8.97656 6.4C8.97656 5.96 8.80535 5.5832 8.46294 5.2696C8.11994 4.95653 7.70781 4.8 7.22656 4.8C6.74531 4.8 6.33348 4.95653 5.99106 5.2696C5.64806 5.5832 5.47656 5.96 5.47656 6.4C5.47656 6.84 5.64806 7.21653 5.99106 7.5296C6.33348 7.8432 6.74531 8 7.22656 8ZM7.22656 16C4.87865 14.1733 3.12515 12.4765 1.96606 10.9096C0.806396 9.3432 0.226562 7.89333 0.226562 6.56C0.226562 4.56 0.930354 2.96667 2.33794 1.78C3.74494 0.593333 5.37448 0 7.22656 0C9.07865 0 10.7082 0.593333 12.1152 1.78C13.5228 2.96667 14.2266 4.56 14.2266 6.56C14.2266 7.89333 13.647 9.3432 12.4879 10.9096C11.3283 12.4765 9.57448 14.1733 7.22656 16Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8e46f218191e2df40889ff6d019ad0c1.svg";
export { ForwardRef as ReactComponent };